const EXEC_QUERY_METHOD = 'dlad_sap_connector.dlad_sap_connector.api.execute_query';
const SUBMIT_DOC = "frappe.desk.form.save.savedocs";

export {
    EXEC_QUERY_METHOD,
    SUBMIT_DOC
}